import lazySizes from 'lazysizes';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// https://github.com/imgix/imgix.js/blob/7b58445832ec520b7d115b107290dfd55223166f/src/targetWidths.js
lazySizes.cfg.rias.widths = [
  100, 116, 134, 156, 182, 210, 244, 282, 328, 380, 442, 512, 594, 688, 798,
  926, 1074, 1246, 1446, 1678, 1946, 2258, 2618, 3038, 3524, 4088, 4742, 5500,
  6380, 7400,
];
